import React, { PureComponent } from 'react';
import { GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class ImporteSinIva extends PureComponent {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        this.props.cambiarImporteConIva(e.target.value);
    }

    onClickFunction(event) {
        let result = event.key == " " ? false : true;
        if (!result) {
            event.preventDefault();
        }
        var rgx = /^[.0-9 ]+$/;
        let resp = rgx.test(event.key);
        if (!resp) {
            event.preventDefault();
        }
    }

    handleChange = (e) => {
        let result = e.target.value == " " ? false : true;
        if (!result) {
            e.preventDefault();
        }

        //Regex que permite solo números y .
        let respregNumPunto = /^[0-9]{1,13}[.]{1}$/;
        let regImporteSinIva = /^[0-9]{1,13}[.][0-9]{1,2}$|^[0-9]{1,13}$/;
        let respregImporteSinIva = regImporteSinIva.test(e.target.value);
        let resprespregNumPunto = respregNumPunto.test(e.target.value);

        if(e.target.value == ""){
            this.props.cambiarImporteConIva(e.target.value, false);
        } else if (respregImporteSinIva) {
            this.props.cambiarImporteConIva(e.target.value, false);
        } else if (resprespregNumPunto) {
            this.props.cambiarImporteConIva(e.target.value, true);
        } else {
            e.preventDefault();
            e.isPropagationStopped();
        }
    }

    render() {
        const me = this;
        const { ingresoAjuste, form, permisos } = this.props;
        const { getFieldProps, getFieldError } = form;

        let permisoDeAlta = permisos && permisos.Alta ? false : true;
        let valor;
        if (ingresoAjuste.accion == "edicion") {
            if (ingresoAjuste.importeSinIva < 0) {
                valor = ingresoAjuste.importeSinIva * -1;
            }
            else valor = ingresoAjuste.importeSinIva
        }
        else {
            valor = ingresoAjuste.importeSinIva;
        }

        let errorImporteSinIva = ingresoAjuste && ingresoAjuste.errorImporteSinIva ?
            <label className="error">Formato Incorrecto</label>
            :
            null;

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-5">
                    <label className="label-primary">Importe Sin IVA *</label>
                    <input
                        onKeyPress={this.onClickFunction}
                        onChange={(e) => this.handleChange(e)}
                        type="text"
                        id="inputImporte"
                        name="inputImporte"
                        value={valor}
                        className="form-control default-input"
                        title="Ingrese Importe."
                        disabled={permisoDeAlta}
                    />
                    {errorImporteSinIva}
                </div>
            </div>
        );
    }
}

export default ImporteSinIva;